import { render } from "./GetAllSectors.vue?vue&type=template&id=7025f2d1"
import script from "./GetAllSectors.vue?vue&type=script&lang=js"
export * from "./GetAllSectors.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__